'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { LinkedInAdTypes } from 'AdsUI/records/reporting/LinkedInAdRecord';

const LIAdSummary = ({
  entity
}) => {
  return /*#__PURE__*/_jsxs(UIList, {
    childClassName: "m-y-1",
    firstChildClassName: "m-bottom-1",
    children: [entity.body && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: entity.body
      })
    }), entity.headline && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: entity.headline
      })
    }), entity.cta && /*#__PURE__*/_jsx(Small, {
      children: entity.type === LinkedInAdTypes.SPOTLIGHT_V2 ? /*#__PURE__*/_jsx(UITruncateString, {
        children: entity.cta
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `creation.leadAd.callsToAction.LINKEDIN.${entity.cta}`
      })
    })]
  });
};

export default LIAdSummary;